(function () {
  window.specialCardService = {
    get() {
      return axios.get(`/api/specialcard/get.php`);
    },
    save(data) {
      return axios.post('/api/specialcard/save.php', data);
    },
    // getActive(data) {
    //   return axios.get('/api/card/active.php');
    // },
  };
})();
